/*
 * @Author: your name
 * @Date: 2020-03-04 13:55:49
 * @LastEditTime: 2022-06-09 21:15:37
 * @LastEditors: haima haima@yaomaitong.cn
 * @Description: In User Settings Edit
 * @FilePath: /home-doctor/src/store/mutation-types.js
 */
//主页
export const GET_INDEX_VISIT_LIST = 'GET_INDEX_VISIT_LIST'
export const GET_INDEX_QUESTIONNAIRE_LIST = 'GET_INDEX_QUESTIONNAIRE_LIST'
export const GET_INDEX_MEETING_LIST = 'GET_INDEX_MEETING_LIST'
export const GET_INVITE_COUNT = 'GET_INVITE_COUNT'
export const GET_INDEX_BANNER = 'GET_INDEX_BANNER'
//商城
export const GET_SHOP_PRODUCT_LIST = 'GET_SHOP_PRODUCT_LIST'
export const GET_CART_LIST = 'GET_CART_LIST'
export const UPDATE_CART_LIST = 'UPDATE_CART_LIST'
export const DETELE_CART_LIST = 'DETELE_CART_LIST'
export const GET_POSTAGE_LIST = 'GET_POSTAGE_LIST'
export const GET_CART_COUNT = 'GET_CART_COUNT'
export const SET_SELECT_ADDRESS = 'SET_SELECT_ADDRESS'
export const MANAGEMENT_COLUMN_LIST = 'MANAGEMENT_COLUMN_LIST'
export const SUBJECT_LIST = 'SUBJECT_LIST'
//地址管理
export const GET_USER_ACCOUNT_INFO = 'GET_USER_ACCOUNT_INFO' // 获取账户余额信息
export const GET_ADDRESS_LIST = 'GET_ADDRESS_LIST'
export const UPDATE_ADDRESS_LIST = 'UPDATE_ADDRESS_LIST'
export const ADD_ADDRESS = 'ADD_ADDRESS'
export const DETELE_ADDRESS = 'DETELE_ADDRESS'
export const SET_DEFAULT_ADDRESS = 'SET_DEFAULT_ADDRESS'
export const SELECT_ADDRESS = 'SELECT_ADDRESS'
//个人
export const GET_SPEAKER_INFO = 'GET_SPEAKER_INFO'
export const UPDATE_SPEAKER_INFO = 'UPDATE_SPEAKER_INFO'
export const GET_DOCTOR_INFO = 'GET_DOCTOR_INFO'
export const UPDATE_DOCTOR_INFO = 'UPDATE_DOCTOR_INFO'
export const CHECK_USER_TOKEN = 'CHECK_USER_TOKEN'
export const SAVE_USER_TOKEN = 'SAVE_USER_TOKEN'
export const CLEAR_USER_TOKEN = 'CLEAR_USER_TOKEN'
export const SAVE_AUTH_USER = 'SAVE_AUTH_USER'
export const GET_DEPARTMENT_LIST = 'GET_DEPARTMENT_LIST'
export const GET_JOB_TITLE_LIST = 'GET_JOB_TITLE_LIST'
export const SET_ID_CARD_INFO = 'SET_ID_CARD_INFO'
export const SET_MODIFY_RECORD_DETAIL = 'SET_MODIFY_RECORD_DETAIL'
export const HANDLE_RECORD_STATE = 'HANDLE_RECORD_STATE'
export const GET_PHARMACY_DETAIL = 'GET_PHARMACY_DETAIL'
export const UPDATE_PHARMACY_INFO = 'UPDATE_PHARMACY_INFO'
export const SET_MODIFY_PHARMACY_DETAIL = 'SET_MODIFY_PHARMACY_DETAIL'
export const HANDLE_PHARMACY_RECORD_STATE = 'HANDLE_PHARMACY_RECORD_STATE'
export const INIT_AREA_MAP = 'INIT_AREA_MAP'
//设置代理信息
export const SET_REPRESENT_INFO = 'SET_REPRESENT_INFO'
// 页面通用
export const SET_PAGE_ORIENTATION = 'SET_PAGE_ORIENTATION'
//请求状态
export const REQUEST_DOING = 'REQUEST_DOING'
export const REQUEST_CLOSE = 'REQUEST_CLOSE'
// 设置标题
export const SET_PAGE_TITLE = 'SET_PAGE_TITLE'
//患者
export const GET_PATIENT_LIST = 'GET_PATIENT_LIST'
export const GET_DOCTOR_LABEL_LIST = 'GET_DOCTOR_LABEL_LIST'
export const CHECK_PATIENT_LABELS = 'CHECK_PATIENT_LABELS'
export const ADD_DOCTOR_LABEL = 'ADD_DOCTOR_LABEL'
export const DETELE_DOCTOR_LABEL = 'DETELE_DOCTOR_LABEL'
export const GET_PATIENT_LABEL_LIST = 'GET_PATIENT_LABEL_LIST'
export const ADD_PATIENT_LABEL = 'ADD_PATIENT_LABEL'
export const DETELE_PATIENT_LABEL = 'DETELE_PATIENT_LABEL'
//趣课堂
export const GET_CONFERENCE_COMMENT_LIST = 'GET_CONFERENCE_COMMENT_LIST'
export const GET_CONFERENCE_KNOWLEDGE_LIST = 'GET_CONFERENCE_KNOWLEDGE_LIST'
export const ADD_CONFERENCE_COMMENT = 'ADD_CONFERENCE_COMMENT'
export const UPDATE_CONFERENCE_COMMENT = 'UPDATE_CONFERENCE_COMMENT'
export const ADD_CONFERENCE_COMMENT_REPLY = 'ADD_CONFERENCE_COMMENT_REPLY'
//趣直播模块
export const GET_INDEX_LIVE_LIST = 'GET_INDEX_LIVE_LIST'
export const GET_INDEX_WEBINAR_LIST = 'GET_INDEX_WEBINAR_LIST'
export const SEND_LIVE_MESSAGE = 'SEND_LIVE_MESSAGE'
export const INIT_LIVE_MESSAGE_LIST = 'INIT_LIVE_MESSAGE_LIST'
export const GET_LIVE_MESSAGE_LIST = 'GET_LIVE_MESSAGE_LIST'
export const DELETE_LIVE_MESSAGE = 'DELETE_LIVE_MESSAGE'
export const UPDATE_LIVE_MESSAGE = 'UPDATE_LIVE_MESSAGE'
export const GET_IM_USER_SIG = 'GET_IM_USER_SIG'
export const CLEAR_BARRAGE_LIST = 'CLEAR_BARRAGE_LIST'
export const ADD_BARRAGE_LIST = 'ADD_BARRAGE_LIST'
export const INIT_LIVE_HISTORY_MESSAGE_LIST = 'INIT_LIVE_HISTORY_MESSAGE_LIST'
export const GET_LIVE_HISTORY_MESSAGE_LIST = 'GET_LIVE_HISTORY_MESSAGE_LIST'
export const GET_LIVE_HISTORY_COMMENT_LIST = 'GET_LIVE_HISTORY_COMMENT_LIST'
export const INIT_REWARD_HELP_LIST = 'INIT_REWARD_HELP_LIST'
export const INIT_REWARD_MY_HELP_LIST = 'INIT_REWARD_MY_HELP_LIST'
//讲者趣直播模块
export const GET_SPEAKER_MESSAGE_LIST = 'GET_SPEAKER_MESSAGE_LIST'
export const ADD_SPEAKER_MESSAGE_LIST = 'ADD_SPEAKER_MESSAGE_LIST'
export const DEL_SPEAKER_MESSAGE_LIST = 'DEL_SPEAKER_MESSAGE_LIST'
export const GET_HISTORY_SPEAKER_MESSAGE_LIST = 'GET_HISTORY_SPEAKER_MESSAGE_LIST'
export const GET_COLLECT_MESSAGE_LIST = 'GET_COLLECT_MESSAGE_LIST'
export const INIT_COLLECT_MESSAGE_LIST = 'INIT_COLLECT_MESSAGE_LIST'
export const DEL_COLLECT_MESSAGE = 'DEL_COLLECT_MESSAGE'
export const GET_LIVE_BLACK_LIST = 'GET_LIVE_BLACK_LIST'
export const INIT_LIVE_BLACK_LIST = 'INIT_LIVE_BLACK_LIST'
export const DEL_BLACK_LIST = 'DEL_BLACK_LIST'
export const UPDATE_SPEAKER_MESSAGE = 'UPDATE_SPEAKER_MESSAGE'
export const DEL_CUSTOM_SPEAKER_MESSAGE_LIST = 'DEL_CUSTOM_SPEAKER_MESSAGE_LIST'
export const UPDATE_TOP_MESSAGE = 'UPDATE_TOP_MESSAGE'
//系统消息
export const GET_SYSTEM_MESSAGE_LIST = 'GET_SYSTEM_MESSAGE_LIST'
export const TIM_SDK_READY = 'TIM_SDK_READY'
// 积分&微信支付
export const SET_AUTH_LINK_NUM = 'SET_AUTH_LINK_NUM'
export const SET_SAVE_PAGE_DATA = 'SET_SAVE_PAGE_DATA'
export const SET_BACK_API_CALL = 'SET_BACK_API_CALL'
export const SET_PARAMS_HOME = 'SET_PARAMS_HOME'
export const SET_PARAMS_RESULT = 'SET_PARAMS_RESULT'
export const SET_PAGE_HOME_DATA = 'SET_PAGE_HOME_DATA'
export const SET_PAGE_RESULT_DATA = 'SET_PAGE_RESULT_DATA'
//帮助中心
export const GET_ARTICLE_LIST = 'GET_ARTICLE_LIST'
export const INIT_ARTICLE_LIST = 'INIT_ARTICLE_LIST'
export const SEARCH_ARTICLE_LIST = 'SEARCH_ARTICLE_LIST'
export const USER_ARTICLE_LIST = 'USER_ARTICLE_LIST'
export const GET_ARTICLE_DETAIL = 'GET_ARTICLE_DETAIL'
export const GET_ARTICLE_MARK = 'GET_ARTICLE_MARK'
export const INIT_ARTICLE_DETAIL = 'INIT_ARTICLE_DETAIL'
export const INIT_USER_ARTICLE = 'INIT_USER_ARTICLE'
export const INIT_SEARCH_LIST = 'INIT_SEARCH_LIST'
export const SET_USER_SPEND_VALID_STATUS = 'SET_USER_SPEND_VALID_STATUS'
// 大咖讲堂
export const IS_SHOW_SPEAKER_HOME = 'IS_SHOW_SPEAKER_HOME'
//首页更新
export const UPDATE_MEETING_LIST = 'UPDATE_MEETING_LIST'
export const UPDATE_QUESTIONNAIRE_LIST = 'UPDATE_QUESTIONNAIRE_LIST'
export const UPDATE_LIVE_LIST = 'UPDATE_LIVE_LIST'
export const UPDATE_NEW_VISIT_LIST = 'UPDATE_NEW_VISIT_LIST'
// 商品
export const GOODS_INFO = 'GOODS_INFO'

// 风控

export const IS_SHOW_RISK = 'IS_SHOW_RISK'
export const RISK_OBJ = 'RISK_OBJ'

// 合同签约
export const LABOUR_AGREE = 'LABOUR_AGREE'

// 平台劳务服务
export const SET_PLATFORM_LABOR_SERVICE = 'SET_PLATFORM_LABOR_SERVICE'
